import React from 'react';
import { useWatch } from 'react-hook-form';
import { MessageSquareHeart } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TextField } from '@/components/text-field';
import { TextAreaField } from '@/components/textarea-field';
import { Switch } from '@/components/switch';
import { TelegramChatIdHelp } from '@/components/telegram-chat-id-help';
import { TelegramChatIdTestButton } from '@/components/telegram-chat-id-test-button';
export function FeedbackConfigCard({ control, disabled, workspaceId, titleField, thankYouField, chatIdField, collectNameField, collectEmailField, }) {
    const { t } = useTranslation('campaign');
    const resolvedChatField = chatIdField ?? 'feedbackTelegramChatId';
    const watchedChatId = useWatch({ control, name: resolvedChatField });
    return (<Card>
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <MessageSquareHeart className="h-4 w-4"/>
                    {t('feedback_config.card_title')}
                </CardTitle>
                <CardDescription>{t('feedback_config.card_desc')}</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                <TextField control={control} name={titleField ?? 'feedbackTitle'} label={t('feedback_config.form_title')} placeholder={t('feedback_config.form_title_placeholder')} description={t('feedback_config.form_title_desc')} disabled={disabled} autoComplete="off"/>
                <TextAreaField control={control} name={thankYouField ?? 'feedbackThankYouMessage'} label={t('feedback_config.thank_you')} placeholder={t('feedback_config.thank_you_placeholder')} description={t('feedback_config.thank_you_desc')} disabled={disabled} autoComplete="off"/>
                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <span className="text-sm font-medium">{t('feedback_config.telegram_chat_id')}</span>
                        <TelegramChatIdHelp workspaceId={workspaceId}/>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex-1">
                            <TextField control={control} name={resolvedChatField} placeholder={t('feedback_config.telegram_chat_id_placeholder')} disabled={disabled} autoComplete="off"/>
                        </div>
                        {workspaceId && (<TelegramChatIdTestButton chatId={watchedChatId} source={{ kind: 'workspace', workspaceId }}/>)}
                    </div>
                    <p className="text-xs text-muted-foreground">{t('feedback_config.telegram_chat_id_hint')}</p>
                </div>
                <div className="grid gap-3 sm:grid-cols-2">
                    <Switch control={control} name={collectNameField ?? 'feedbackCollectName'} label={t('feedback_config.collect_name')} description={t('feedback_config.collect_name_desc')}/>
                    <Switch control={control} name={collectEmailField ?? 'feedbackCollectEmail'} label={t('feedback_config.collect_email')} description={t('feedback_config.collect_email_desc')}/>
                </div>
            </CardContent>
        </Card>);
}
